module.exports = __webpack_public_path__ + "35980622876c1f5b1eaea7ac77ea7e0a.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_launch/verify_receipt/icon-document.png
// module id = 3433
// module chunks = 69